// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"362":"115f12a1","654":"115f12a1","716":"4d1329fb","771":"115f12a1"}[chunkId] + ".chunk.css";
};